import React from 'react';

import { ProductDetails } from 'types/state';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { formatDate } from 'utils/formatDate';
import { SidebarModalSectionComponent } from 'design/sidebarModal';
import { TextComponent } from 'design/text/textComponents';
import {
  SmallTableRowComponent,
  SmallTableWrapperComponent,
} from 'design/smallTable';
import { MarginComponent } from 'design/margin';

type Props = {
  details: ProductDetails;
};

export const ProductManagerArchive = (props: Props) => {
  const { details } = props;

  const { archivedTariffs } = details;

  const { productDetails: intl, shared } = useIntlDictionary();

  const createDurationText = React.useCallback(
    (ISODateStartsAt: string, ISODateExpiresAt: string) => {
      const startsAt = formatDate(ISODateStartsAt, 'DD.MM.YY');

      const expiresAt = formatDate(ISODateExpiresAt, 'DD.MM.YY');

      return intl.table.durationValue(startsAt, expiresAt);
    },
    [intl.table]
  );

  const tariffTableNodes = React.useMemo(
    () =>
      archivedTariffs.map((tariff) => (
        <React.Fragment key={tariff.id}>
          <SmallTableWrapperComponent>
            <SmallTableRowComponent>
              <TextComponent weight="medium">
                {intl.table.costLabel}
              </TextComponent>
              <TextComponent weight="medium">{tariff.cost}</TextComponent>
            </SmallTableRowComponent>
            <SmallTableRowComponent>
              <TextComponent>{intl.table.durationLabel}</TextComponent>
              <TextComponent>
                {createDurationText(tariff.startsAt, tariff.expiresAt)}
              </TextComponent>
            </SmallTableRowComponent>
            <SmallTableRowComponent>
              <TextComponent>{intl.table.createdAtLabel}</TextComponent>
              <TextComponent>
                {shared.dates.calendarDateWithTime(new Date(tariff.createdAt))}
              </TextComponent>
            </SmallTableRowComponent>
            <SmallTableRowComponent>
              <TextComponent>{intl.table.idLabel}</TextComponent>
              <TextComponent>{tariff.id}</TextComponent>
            </SmallTableRowComponent>
          </SmallTableWrapperComponent>
          <MarginComponent top={40} />
        </React.Fragment>
      )),
    [
      archivedTariffs,
      createDurationText,
      intl.table.costLabel,
      intl.table.createdAtLabel,
      intl.table.durationLabel,
      intl.table.idLabel,
      shared.dates,
    ]
  );

  // return <ClientDetailsBlock mod="table" primaryContent={tariffTableNodes} />;

  return (
    <SidebarModalSectionComponent
      content={tariffTableNodes}
      actions={null}
      navigation={null}
    />
  );
};
